// extracted by mini-css-extract-plugin
export default {"appstore":"_0aYKV0G1--AppleAppStoreLink_appstore__g9jkK"};